import React from 'react'
import { useMessaging } from './MessagingProvider'
import CoachMessageThread from './CoachMessageThread'
import NewMessage from './NewMessage'
import NewSupportMessage from './NewSupportMessage'
import ThreadList from './ThreadList'
import SentList, { SentMessage } from './SentList'
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '~/lib/ui/resizable'
import { ScrollArea } from '~/lib/ui/scroll-area'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '~/lib/ui/tabs'
import useTranslation from '~/components/shared/TranslationProvider'
import { Button } from '~/lib/ui/button'

const Layout = () => {
  const { isMobile } = useMessaging()

  return isMobile ? <MobileLayout /> : <DesktopLayout />
}
export default Layout

const InboxSentTabs = () => {
  const { t } = useTranslation('CoachMessageThread')
  const { setViewingSentMessages, setCurrentSentMessage, clearNewMessageMode } =
    useMessaging()
  const handleTabChange = (value) => {
    setViewingSentMessages(value === 'sent')
    setCurrentSentMessage({})
    clearNewMessageMode()
  }

  return (
    <Tabs className="Tabs" defaultValue="inbox" onValueChange={handleTabChange}>
      <TabsList className="ml-4 w-11/12">
        <TabsTrigger className="w-1/2" value="inbox">
          {t('inbox')}
        </TabsTrigger>
        <TabsTrigger className="w-1/2" value="sent">
          {t('sent')}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="inbox">
        <ThreadList />
      </TabsContent>
      <TabsContent value="sent">
        <SentList />
      </TabsContent>
    </Tabs>
  )
}

const SelectMessageType = () => {
  const { t } = useTranslation('CoachMessageThread')
  const { setNewMessageType, setNewMessageMode, coach, programIsSilver } =
    useMessaging()

  const cancelNewMessage = () => {
    setNewMessageType(null)
    setNewMessageMode(false)
  }
  return (
    <div className="flex flex-col gap-y-2 p-4">
      {coach && !programIsSilver && (
        <Button variant="coachcta" onClick={() => setNewMessageType('coach')}>
          {t('message_your_coach')}
        </Button>
      )}
      <Button
        variant="coachcta"
        onClick={() => setNewMessageType('tech_support')}
      >
        {t('message_technical_support')}
      </Button>
      <Button variant="coachcta" onClick={() => setNewMessageType('feedback')}>
        {t('send_feedback')}
      </Button>
      {coach && (
        <Button
          variant="coachcta"
          onClick={() => setNewMessageType('coach_support')}
        >
          {t('message_coach_support')}
        </Button>
      )}
      <Button variant="outline" onClick={cancelNewMessage}>
        {t('cancel')}
      </Button>
    </div>
  )
}

const MobileLayout = () => {
  const {
    newMessageMode,
    newMessageType,
    currentThreadId,
    viewingSentMessages,
  } = useMessaging()

  const currentMobileView = () => {
    if (newMessageMode) {
      if (newMessageType) {
        return (
          <div className="p-4">
            <NewMessage />
          </div>
        )
      } else {
        return <SelectMessageType />
      }
    } else if (viewingSentMessages) {
      return (
        <div className="p-4">
          <SentMessage />
        </div>
      )
    } else if (currentThreadId) {
      return (
        <div className="p-4">
          <CoachMessageThread />
        </div>
      )
    } else {
      return (
        <div className="md:h-[calc(100vh-310px)]">
          <InboxSentTabs />
        </div>
      )
    }
  }
  return <div>{currentMobileView()}</div>
}

const DesktopLayout = ({ defaultLayout = [40, 60] }) => {
  const { newMessageType, newMessageMode, viewingSentMessages } = useMessaging()
  const NewMessageComp = newMessageType
    ? newMessageType == 'coach'
      ? NewMessage
      : NewSupportMessage
    : SelectMessageType
  const ViewMessageComp = viewingSentMessages ? SentMessage : CoachMessageThread

  return (
    <ResizablePanelGroup direction="horizontal" className="h-full md:px-5">
      <ResizablePanel defaultSize={defaultLayout[0]} minSize={30}>
        <div className="pr-4 pt-4">
          <ScrollArea className="md:h-[calc(100vh-310px)]">
            <InboxSentTabs />
          </ScrollArea>
        </div>
      </ResizablePanel>
      <ResizableHandle withHandle className="bg-white" />
      <ResizablePanel
        defaultSize={defaultLayout[1]}
        minSize={30}
        className="flex h-[calc(100vh-310px)] flex-col p-4"
      >
        {newMessageMode ? <NewMessageComp /> : <ViewMessageComp />}
      </ResizablePanel>
    </ResizablePanelGroup>
  )
}
